import type { GlobalAttributesLocation, PerseusEvent, PerseusSession } from './types'

const ALPHA_CHARS = 'abcdefghijklmnopqrstuvwxyz'
const DIGIT_CHARS = '0123456789'
const ALPHA_NUMERIC_CHARS = ALPHA_CHARS + DIGIT_CHARS

function generateRandomString(length: number, characters = ALPHA_NUMERIC_CHARS) {
  let result = ''
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length))
  }
  return result
}

export function generateUniqueId(): string {
  const timestamp = new Date().getTime()
  const randomNum = generateRandomString(18, DIGIT_CHARS)
  const randomStr = generateRandomString(10)

  return `${timestamp}.${randomNum}.${randomStr}`
}

export function isValidPerseusSession(session: unknown): session is PerseusSession {
  return session &&
    typeof session === 'object' &&
    'id' in session &&
    isValidId(session.id) &&
    'timestamp' in session &&
    typeof session.timestamp === 'number'
    ? true
    : false
}

export function isValidId(clientId: unknown): clientId is string {
  return typeof clientId === 'string'
}

export function isValidEvent(event: unknown): event is PerseusEvent {
  return event &&
    typeof event === 'object' &&
    'name' in event &&
    typeof event.name === 'string' &&
    'attributes' in event &&
    event.attributes &&
    typeof event.attributes === 'object'
    ? true
    : false
}

export const getLocationDataFromGlobalAttributes = (
  globalAttributes: Record<string, unknown>
): GlobalAttributesLocation | null => {
  if (!globalAttributes.location || typeof globalAttributes.location !== 'object') {
    return null
  }

  const location =
    typeof globalAttributes.location === 'object'
      ? {
          locationCity:
            'locationCity' in globalAttributes.location &&
            typeof globalAttributes.location.locationCity === 'string'
              ? globalAttributes.location.locationCity
              : null,
          locationCountry:
            'locationCountry' in globalAttributes.location &&
            typeof globalAttributes.location.locationCountry === 'string'
              ? globalAttributes.location.locationCountry
              : null,
          locationLat:
            'locationLat' in globalAttributes.location
              ? `${globalAttributes.location?.locationLat}`
              : null,
          locationLon:
            'locationLon' in globalAttributes.location
              ? `${globalAttributes.location?.locationLon}`
              : null,
        }
      : null

  return location
}
